export default "__VITE_ASSET__BceBkycT__"